import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Message } from '@/src/elements/message'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { ICON } from '@/src/general/enums/icons'

import type { COMMUNITY_LIFETIME } from '../../../models/community.constants'

type TCommunityEmptyMessageProps = {
  isEverlasting: boolean
  lifetime: COMMUNITY_LIFETIME
}

export const CommunityEmptyMessage = ({ isEverlasting, lifetime }: TCommunityEmptyMessageProps) => (
  <View className="md:mx-auto w-screen pb-4 md:w-[720px] px-5">
    <Spacer y={32} />
    {isEverlasting && (
      <Message iconName={ICON.BOOK_OPEN}>
        <FormattedMessage id="community.everlasting.unavailable-program" />
      </Message>
    )}
    {!isEverlasting && (
      <Message iconName={ICON.PATH}>
        <FormattedMessage id="community.unavailable-program" values={{ lifetime }} />
      </Message>
    )}
  </View>
)
